// extracted by mini-css-extract-plugin
module.exports = {"Chart":"Chart_Chart__ei5Ur","hide-tradingview":"Chart_hide-tradingview__3Hnk2","parent":"Chart_parent__quqtH","full-screen":"Chart_full-screen__qfk-f"};